// src/lib/partner/partnerProgrammeActivity.js

import { supabase } from "../../supabaseClient";

const DEFAULT_PAGE_SIZE = 50;
const MAX_PAGE_SIZE = 100;

function normaliseLimit(value) {
  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    return DEFAULT_PAGE_SIZE;
  }

  return Math.max(
    1,
    Math.min(
      Math.floor(parsed),
      MAX_PAGE_SIZE
    )
  );
}

function normaliseOffset(value) {
  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    return 0;
  }

  return Math.max(
    0,
    Math.floor(parsed)
  );
}

export async function fetchPartnerProgrammeActivity({
  limit = DEFAULT_PAGE_SIZE,
  offset = 0,
} = {}) {
  const safeLimit =
    normaliseLimit(limit);

  const safeOffset =
    normaliseOffset(offset);

  const {
    data,
    error,
  } = await supabase.rpc(
    "get_my_partner_programme_activity",
    {
      p_limit: safeLimit,
      p_offset: safeOffset,
    }
  );

  if (error) {
    throw error;
  }

  return Array.isArray(data)
    ? data
    : [];
}

export {
  DEFAULT_PAGE_SIZE,
};